// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.48063 2.5H1V9H23V5H11.4806L9.48063 2.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 11H1V21H23V11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-1-filled')
export default class Folder1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-1-filled',
    }
  }
}
